import consola from 'consola'

consola.level = process.env.VUE_APP_LOG_LEVEL || 5
// make all console.log go to consola
consola.wrapConsole()

export default function useLogger (logNamespace) {
  return consola.withTag(logNamespace || 'r4')
}
